import { Box, Container, Grid, Typography } from '@mui/material';
import { Title } from '../../components/Title';
import { accountService, UserRole } from '../../account.service';
import { Navigate } from 'react-router-dom';

export const Settings = () => {
    const account = accountService.getAccount();

    return (
        <>
            {(!account || account.role !== UserRole.Admin) && <Navigate to="/account/login" />}
            <Title title="Settings" />
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 8,
                }}
            >
                <Container maxWidth={false}>
                    <Grid container justifyContent="space-between" spacing={3}>
                        <Grid item>
                            <Typography color="textPrimary" variant="h5">
                                Settings
                            </Typography>
                        </Grid>
                    </Grid>
                    <Box sx={{ mt: 3 }}>
                        <Typography color="textSecondary" variant="body2">
                            Dashboard settings
                        </Typography>
                    </Box>
                </Container>
            </Box>
        </>
    );
};
